export const textConstants = {    
    UPDATE_REQUEST: 'TEXT_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'TEXT_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'TEXT_UPDATE_FAILURE',
    
    FETCH_REQUEST: 'TEXT_FETCH_REQUEST',
    FETCH_SUCCESS: 'TEXT_FETCH_SUCCESS',
    FETCH_FAILURE: 'TEXT_FETCH_FAILURE',   

    GET_REQUEST: 'TEXT_GET_REQUEST',
    GET_SUCCESS: 'TEXT_GET_SUCCESS',
    GET_FAILURE: 'TEXT_GET_FAILURE',
};
